import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { FractionalQuantity } from '../FractionalQuantity/FractionalQuantity'
import Dollars from '../../Dollars/Dollars'
import Button from '../../Button/Button'
import { EditItem } from '../../NestedModifiers/EditItem/EditItem'
import { CartTableModifiersList } from './CartTableModifiersList/CartTableModifiersList'
import { RemoveItemButton } from '../RemoveItemButton/RemoveItemButton'
import { useDeleteItemFromCart } from '../../CartMutation/CartMutation'

import './CartTable.css'

const CartTable = ({ cart, editable = false }) => {
  const [currentEditGuid, setEditGuid] = useState(null)
  const [onDelete, { loading }] = useDeleteItemFromCart()
  return (
    <table styleName={cx('table', { readonly: !editable })}>
      <tbody>
        {cart.order.selections.map((selection, index) => {
          const {
            name,
            price,
            preDiscountPrice,
            guid,
            modifiers,
            itemGroupGuid,
            itemGuid,
            usesFractionalQuantity,
            fractionalQuantity
          } = selection
          const key = guid || index

          return (
            <tr data-testid='cart-item-body' key={key}>
              <td data-testid='cart-item-quantity' valign='top' styleName='title number'>
                {selection.quantity}
              </td>
              <td data-testid='cart-item-info' styleName='info'>
                <span data-testid='cart-item-name' styleName='title'>{name}</span>
                {usesFractionalQuantity && (<FractionalQuantity {...fractionalQuantity} />)}
                {modifiers.length > 0 && <CartTableModifiersList editable={editable} modifiers={modifiers} />}
                {editable && (
                  <React.Fragment>
                    <Button
                      disabled={loading}
                      data-testid='cart-item-edit'
                      onClick={() => setEditGuid(selection.guid)}
                    >
                    Edit
                    </Button>
                    <RemoveItemButton
                      loading={loading}
                      onDelete={onDelete}
                      cartGuid={cart.guid}
                      selectionGuid={selection.guid}
                    />
                  </React.Fragment>
                )}
                {selection.guid === currentEditGuid && (
                  <EditItem
                    cartGuid={cart.guid}
                    selectionGuid={selection.guid}
                    itemGuid={itemGuid}
                    itemGroupGuid={itemGroupGuid}
                    onClose={() => setEditGuid(null)}
                  />
                )}
              </td>
              <td data-testid='item-price' styleName='number' valign='top'>
                <Dollars amount={preDiscountPrice || price} />
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

CartTable.propTypes = {
  cart: PropTypes.object.isRequired,
  editable: PropTypes.bool
}

export default CartTable
